export const API: any = {
  DEV: () => 'https://api-sbx.nominasaps.com/api/v2/',
  STAGGING: () => 'https://api-sbx.nominasaps.com/api/v2s/',
  PROD: () => 'https://api-next.nominasaps.com/api/v2/',
  PREVIEW: () => {
    // get the pr number from the url
    const prName = window.location.hostname.split('.')[0]
    return `https://api-preview.nominasaps.com/${prName}/api/v2/`
  },
  PREVIEW_NEW: () => {
    return `https://api-preview.nominasaps.com/preview/api/v2/`
  }
}

export const API_NEW: any = {
  DEV: () => 'https://a6mnlwgjnj.execute-api.us-east-1.amazonaws.com/public/',
  STAGGING: () =>
    'https://a6mnlwgjnj.execute-api.us-east-1.amazonaws.com/public/',
  PROD: () => 'https://dbbgzmjy47.execute-api.us-east-1.amazonaws.com/public/',
  PREVIEW: () =>
    'https://a6mnlwgjnj.execute-api.us-east-1.amazonaws.com/public/',
  PREVIEW_NEW: () =>
    'https://a6mnlwgjnj.execute-api.us-east-1.amazonaws.com/public/'
}

/**
 * API GW del nuevo modulo de payroll (dominio propio, distinto de API/API_NEW).
 * Expone, entre otros, el servicio de documentos: /documents/payment-slips.
 *
 * Cada ambiente valida el JWT contra el pool de Cognito de SU cuenta, asi que
 * apuntar a la URL de otro ambiente devuelve 401 aunque la sesion sea valida.
 * Los ambientes sin infraestructura propia usan dev, igual que API_NEW.
 */
export const API_PAYROLL: any = {
  DEV: () => 'https://api.payroll-dev.nominasaps.com/',
  STAGGING: () => 'https://api.payroll-dev.nominasaps.com/',
  PROD: () => 'https://api.payroll.nominasaps.com/',
  PREVIEW: () => 'https://api.payroll-dev.nominasaps.com/',
  PREVIEW_NEW: () => 'https://api.payroll-dev.nominasaps.com/'
}

export const SET_WORKSPACE_PERMISSION = 'user:set_workspace'
export const VERSION = () => import.meta.env.VITE_VERSION || 'v2.510.4-main(4511e84)'
export const ENV = () => {
  const env = () => import.meta.env.VITE_ENV || 'PROD' // DEV PROD STAGGING PREVIEW
  return env().includes('ENV') ? 'DEV' : env()
}

/**
 * Client-side environment key de Flagsmith, por ambiente.
 * Las keys client-side NO son secretas (viajan al browser), por lo que se
 * hardcodean por ambiente igual que las URLs de API. Se puede sobreescribir
 * con VITE_FLAGSMITH_ENV_ID para pruebas locales.
 * Todos los ambientes usan el environment de Develop excepto PROD.
 */
export const FLAGSMITH_ENVIRONMENT_ID: Record<string, () => string> = {
  DEV: () => import.meta.env.VITE_FLAGSMITH_ENV_ID || '6QcXyzyfDxy8Wr8BSMAWjW',
  STAGGING: () =>
    import.meta.env.VITE_FLAGSMITH_ENV_ID || '6QcXyzyfDxy8Wr8BSMAWjW',
  PROD: () => import.meta.env.VITE_FLAGSMITH_ENV_ID || '2FSztKEkJVmWAJTFJahkLo',
  PREVIEW: () =>
    import.meta.env.VITE_FLAGSMITH_ENV_ID || '6QcXyzyfDxy8Wr8BSMAWjW',
  PREVIEW_NEW: () =>
    import.meta.env.VITE_FLAGSMITH_ENV_ID || '6QcXyzyfDxy8Wr8BSMAWjW'
}
